import { FC } from 'react';

export const Divider: FC = () => (
    <div className="mx-4 h-8 w-[1px] bg-white/40 dark:bg-accent-foreground/40" />
);
